import React from "react";
import {ChipLabel} from "./index";

const RiaWarningChip = ({type}) => {
    const typeData = {
        "pending": {
            class: "status-chip warning",
            text: "Pending"
        },
        "resolved": {
            class: "status-chip success",
            text: "Domain Approved"
        },
        "ignored": {
            class: "status-chip default",
            text: "Domain Rejected"
        },
        "allowed_domain": {
            class: "status-chip secondary",
            text: "Domain is not allowed"
        },
    }

    return (<ChipLabel label={typeData[type]?.text} className={typeData[type]?.class}/>)
}

export default RiaWarningChip;
